import { gql } from 'graphql-request'

export const COMMENTS = gql`
  query Comments(
    $limitPerPage: Int
    $page: Int
    $where: CommentWhere
    $sort: String
  ) {
    comments(
      limitPerPage: $limitPerPage
      page: $page
      where: $where
      sort: $sort
    ) {
      data {
        id
        content
        childrenComment {
          id
          content
          likeCount
          isLiked
          replied {
            user {
              id
            }
            id
          }
          user {
            id
            displayName
            avatarImgPath
            profilePageSlug
            email
            isAdmin
            isPermanentBan
          }
          visible
          createdAt
          parentComment {
            user {
              id
              profilePageSlug
            }
          }
          updatedBy {
            id
          }
        }
        isLiked
        likeCount
        user {
          id
          isAdmin
          displayName
          avatarImgPath
          profilePageSlug
          email
          isAdmin
          isPermanentBan
        }
        bookChapter {
          chapterName
        }
        visible
        createdAt
        updatedBy {
          id
        }
      }
      total
      page
    }
  }
`
